module.exports = __webpack_public_path__ + "static/media/equal.51bd8c8d.svg";